// Mapping for tranche effectifs
export const trancheEffectifsLabels: Record<string, string> = {
  '00': 'Pas d\'effectif',
  '01': '1 ou 2 salariés',
  '02': '3 à 5 salariés',
  '03': '6 à 9 salariés',
  '11': '10 à 19 salariés',
  '12': '20 à 49 salariés',
  '21': '50 à 99 salariés',
  '22': '100 à 199 salariés',
  '31': '200 à 249 salariés',
  '32': '250 à 499 salariés',
  '41': '500 à 999 salariés',
  '42': '1 000 à 1 999 salariés',
  '51': '2 000 à 4 999 salariés',
  '52': '5 000 à 9 999 salariés',
  '53': '10 000 salariés et plus',
  'NN': 'Non renseigné',
};

// Mapping for categorie entreprise
export const categorieEntrepriseLabels: Record<string, string> = {
  'PME': 'Petite ou Moyenne Entreprise',
  'ETI': 'Entreprise de Taille Intermédiaire',
  'GE': 'Grande Entreprise',
}; 